// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6736ef0b","453":"69b5d72e","455":"df658cab","977":"870aa915"}[chunkId] + ".chunk.js";
};